import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Dataflow04 = function Dataflow04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 18v-.2c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C6.2798 13 7.1198 13 8.8 13h6.4c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C20 15.2798 20 16.1198 20 17.8v.2M4 18c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m16 0c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m-8 0c-1.1046 0-2 .8954-2 2s.8954 2 2 2 2-.8954 2-2-.8954-2-2-2m0 0V8M6 8h12c.9319 0 1.3978 0 1.7654-.1522.49-.203.8794-.5924 1.0824-1.0824C21 6.3978 21 5.9319 21 5s0-1.3978-.1522-1.7654a2 2 0 0 0-1.0824-1.0824C19.3978 2 18.9319 2 18 2H6c-.9319 0-1.3978 0-1.7654.1522a2 2 0 0 0-1.0824 1.0824C3 3.6022 3 4.0681 3 5s0 1.3978.1522 1.7654a2 2 0 0 0 1.0824 1.0824C4.6022 8 5.0681 8 6 8"
    })
  }));
};
export default Dataflow04;